import axios from "axios";
import { CMS_API_ENDPOINT } from "../constants/api-constants";
import { QuizData, QuizQuestion } from "../types/Quiz";

export async function fetchQuizQuestions(): Promise<QuizData> {
    try {
        const response = await axios.get(
            `${CMS_API_ENDPOINT}/quiz-questions?sort=createdAt&limit=300`
        );

        const questions = response.data.docs.map((doc: any, index: number) => ({
            ID: index,
            category: doc.category,
            question: doc.question,
            A: doc.answerA,
            B: doc.answerB,
            C: doc.answerC,
            D: doc.answerD,
            correct_answer: doc.correctAnswer,
        }));

        return { questions };
    } catch (error) {
        throw new Error(`Failed to fetch quiz data: ${error}`);
    }
}

export function getQuestionsByCategory(
    quizData: QuizData,
    category: string
): QuizQuestion[] {
    return quizData.questions.filter((q) => q.category === category);
}

export function pickRandomQuestions(
    questions: QuizQuestion[],
    num: number
): QuizQuestion[] {
    const shuffled = [...questions].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, num);
}

export function generateQuiz(quizData: QuizData): QuizQuestion[] {
    const easyQuestions = getQuestionsByCategory(quizData, "HSV - leicht");
    const mediumQuestions = getQuestionsByCategory(quizData, "HSV - mittel");
    const hardQuestions = getQuestionsByCategory(quizData, "HSV - schwer");
    const nxpQuestions = getQuestionsByCategory(quizData, "NXP");

    const easy = pickRandomQuestions(easyQuestions, 3);
    const medium = pickRandomQuestions(mediumQuestions, 2);
    const hard = pickRandomQuestions(hardQuestions, 2);
    const nxp = pickRandomQuestions(nxpQuestions, 1);

    const allQuestions = [...easy, ...medium, ...hard, ...nxp];

    return allQuestions.sort(() => 0.5 - Math.random());
}
